import React from "react";

import "./App.css";

import Main from "./components/Main/Main";

function App() {
	return (
		<div>
			<Main></Main>
		</div>
	);
}

export default App;
